import React, { useState, useEffect, useRef, useMemo } from 'react';
import { classNames } from 'primereact/utils';
import { InputText } from 'primereact/inputtext';
import { Dialog } from 'primereact/dialog';
import { Button } from 'primereact/button';
import { useFormik } from 'formik';
import { Toast } from 'primereact/toast';
import { translatedMessage } from '../../service/LanguageService';
import { Calendar } from 'primereact/calendar';
import { AdministrationService } from '../../service/AdministrationService';

const emptyRecord = {
    id: null,
    name: '',
    date: ''
};

const HolidayEditDialog = (props) => {

    const [holiday, setHoliday] = useState(emptyRecord);
    const [dialogVisible, setDialogVisible] = useState(false);
    const [isNew, setIsNew] = useState(false);

    const toast = useRef(null);

    const administrationService = useMemo(() => new AdministrationService(), []);

    useEffect(() => {
        setHoliday(props.value ? props.value : emptyRecord);
        setIsNew(props.value ? false : true);
    }, [props.value]);

    useEffect(() => {
        setDialogVisible(props.visible);
    }, [props.visible]);

    const hideDialog = () => {
        if (typeof props.visibleSetter === 'function') {
            props.visibleSetter(false);
        }
        setDialogVisible(false);
        formik.resetForm();
    };

    const saveHoliday = (data) => {
        administrationService.saveHoliday(data)
            .then(savedHoliday => {
                if (typeof props.afterSave === 'function') {
                    props.afterSave(savedHoliday, isNew);
                }

                toast.current.show({ severity: 'success', summary: translatedMessage("generic.save.success") })
                hideDialog();
            })
            .catch(error => {
                toast.current.show({ severity: 'error', summary: translatedMessage(error), life: 5000 })
            });
    };

    const formik = useFormik({
        enableReinitialize: true,
        initialValues: holiday,
        validate: (data) => {
            let errors = {};

            if (!data.name) {
                errors.name = translatedMessage('form.error.name.required');
            }
            if (!data.date) {
                errors.date = translatedMessage('form.error.holiday.date.required');
            }
            return errors;
        },
        onSubmit: (data) => {
            // console.log("save holiday: ", data)
            saveHoliday(data);
        }
    });

    const isFormFieldValid = (name) => !!(formik.touched[name] && formik.errors[name]);

    const getFormErrorMessage = (name) => {
        return isFormFieldValid(name) && <small className="p-error text-align-left">{formik.errors[name]}</small>;
    };

    const holidayDialogFooter = (
        <>
            <Button label={translatedMessage('generic.cancel')} icon="pi pi-times" className="p-button-text" onClick={hideDialog} />
            <Button label={translatedMessage('generic.save')} icon="pi pi-save" className="p-button-text" form="holiday-form" type="submit" />
        </>
    );

    return (
        <>
            <Toast ref={toast} />
            <Dialog
                visible={dialogVisible}
                style={{ width: '450px' }}
                header={translatedMessage('generic.details')}
                modal
                className="p-fluid"
                footer={holidayDialogFooter}
                onHide={hideDialog}
            >
                <form id="holiday-form" onSubmit={formik.handleSubmit}>
                    <div className="form p-inputgroup mt-3 mb-2">
                        <span className="p-float-label">
                            <InputText type="text" id="name" name="name" value={formik.values.name} onChange={formik.handleChange} autoFocus className={classNames({ 'p-invalid': isFormFieldValid('name') })} />
                            <label htmlFor="name" className={classNames({ 'p-error': isFormFieldValid('name') })}>
                                {translatedMessage("generic.nameRo")} *
                            </label>
                        </span>
                    </div>
                    {getFormErrorMessage('name')}

                    <div className="field p-inputgroup mt-3 mb-2">
                        <span className="p-float-label">
                            <Calendar id="date" name="date" value={formik.values.date} onChange={formik.handleChange} dateFormat="dd-mm-yy"
                                className={classNames({ 'p-invalid': isFormFieldValid('date') })} />
                            <label htmlFor="date" className={classNames({ 'p-error': isFormFieldValid('date') })}>
                                {translatedMessage("holiday.date")} *
                            </label>
                        </span>
                    </div>
                    {getFormErrorMessage('date')}
                </form>
            </Dialog>
        </>
    );
};

export default HolidayEditDialog;
